import '../Pulsar.css';
import img0 from '../todos_recursos/25pts.jpg';
import img1 from '../todos_recursos/mossensorell.jpg';
import img2 from '../todos_recursos/fistros.jpg';
import img3 from '../todos_recursos/tazosChikito.jpg';
import img4 from '../todos_recursos/tazosJuego.jpg';
import img5 from '../todos_recursos/fichaAlquiler.jpg';



function Article1() {

    return(
<>

        <h1>Precio joven</h1>
        <h2>25 pesetas.</h2>
        <p>
        <img src={img0} alt='Moneda de 25 pesetas de Sevilla 92' className="imagenIzq" width="30%"/>
        El simple título del artículo ya nos traslada a un momento en el tiempo, cargado de emociones y sabores. Y sí, hablamos de la promoción de <strong>Matutano</strong> donde se vendían bolsas de 
        papas y snacks de tamaño reducido a un precio de 25 pts. Personalmente, el recuerdo de esto es tremendo, ya que por fin podías degustar estas delicias a un precio alcanzable 
        para los reducidos bolsillos de los jóvenes; estos productos, antes de la promoción, eran bastante difíciles de asumir, pues era sinónimo de no poder comprar nada más.
        </p>

        <p>
        En aquel entonces recuerdo que vivíamos en el <strong>barrio del Carmen de Valencia</strong>, es la parte del casco viejo de la ciudad, lo que actualmente se conoce como <i>«Ciutat Vella»</i>. 
        Estábamos muy próximos al mercado de Mossén Sorell, donde era habitual que mi madre me llevara a realizar algunas compras necesarias.
        </p>
            <a href='https://valencianoticias.com/historia-del-mercado-municipal-de-mossen-sorell/'><img src={img1} alt='Mercado Mossen Sorell' className='imagenGrande' /></a>
        <p>
            La imagen de arriba plasma el mercado, pero es actual y ya aparece renovado; en mi recuerdo era mucho más, digamos, años 90. En aquel entonces no era un sitio muy 
            apreciado para vivir, ya que existían muchos movimientos (okupa, punk, skins) que causaban bastantes conflictos. Además, el barrio se encontraba bastante degradado al ser 
            antiguo y no haber sufrido remodelaciones. Quitando esto, la imagen nos viene perfecta para situarnos: en la parte izquierda, justo en la esquina donde se ve el edificio, 
            en ese bajo con los toldos verdes, existía una bodega. En este antiguo establecimiento fue donde por primera vez vi esos magníficos paquetes de Matutano con el precio joven.
             Recuerdo perfectamente ese característico olor que tenía el local, pues era fruto de los efluvios de los vinos y licores que allí se comercializaban; creo que también 
             vendían encurtidos, pero mi mente de niño no asociaba ese olor a las bebidas, sino a los manjares embolsados que allí tenían. Los que recordáis esa promoción sabéis 
             perfectamente que, aparte del precio y del snack, existía otro aliciente que producía un fuerte magnetismo para querer poseer esas bolsas: <strong>los chiqui-tazos</strong>.
        </p>
            <img src={img2} alt='Bolsa de sancks de la promoción precio joven de Matutano' className="imagenCentrada" width="40%"/>
        <h2>Los tazos.</h2>
        <p>
            Aunque han existido diferentes temáticas de tazos, y si no me equivoco aún se siguen promocionando, esa campaña inicial fue absolutamente mágica, porque eran los tazos de <strong>Chiquito de la Calzada</strong>. No sé qué clase de encantamiento tuvo ese alineamiento de tamaño, precio y juego, pero desde luego alguien en esa empresa recibió una inspiración 
            divina, porque esto marcó toda una época y generación. El mayor objetivo del día era conseguir ganar a tus amigos y arrebatarles sus tazos durante el recreo del colegio; 
            veías los tazos en la tele, en el cole, en la calle... No deja de sorprenderme cómo un objeto tan simple, pues era una chapa de plástico con una impresión encima, pudiera 
            llegar a tener una repercusión y un éxito tan grandes. Cabe decir que la impresión del gran humorista Chiquito no era cualquier cosa, e imbuía a estos objetos de forma 
            única. Hay que destacar que Chiquito de la Calzada no fue una moda; se convirtió en un gran humorista muy apreciado en nuestro país durante toda su vida, en la que además 
            gozó con la fama de ser una magnífica persona. 
        </p>

            <img src={img3} alt='Tazos de chikito de la calzada' className="imagenCentrada" width="60%"/>
        
        <p>    
            Mis tazos ya no eran como los de la imagen, puesto que estaban <strgon>desgastados y descoloridos</strgon> de tanto usarlos. Aún recuerdo hasta tácticas y diferentes formas de jugar con 
            ellos; en el propio envoltorio —y debo admitir que buscando las imágenes para el artículo ha sido cuando lo he recordado— ya nos indicaban la forma de jugar con ellos, 
            que además venía acompañado, cómo no, de unos cortos chistes de la época que difícilmente hoy en día podrían ver la luz sin levantar una gran polémica.
        </p>
            <img src={img4} alt='Parte trasera de envoltorio de fistros' className="imagenCentrada" style={{width: '55%'}}/>
            <h2>Los kioscos y algo más.</h2>
 
        <p>
            Justo enfrente de la bodega que hemos comentado al inicio existía un kiosco donde, en cuanto decidieron comercializar estos snacks de Matutano, me haría dar el salto a 
            realizar mis compras ahí; evidentemente era mucho más atractivo a los ojos de un niño que una bodega. Además, con este «precio joven» te podías permitir montarte un 
            magnífico «menú» más que digno por veinte duros. Pero este negocio tenía algo muy peculiar y típico de aquellos años, pues se mezclaba con otra actividad que desgraciadamente
             ya no existe, un tipo de negocio que llegó a ser uno de los más florecientes de la época, pero que no pudo soportar los embistes que el futuro le tenía preparados; una actividad
              que, sin duda, se merece un artículo aparte. 
        </p>
            <img src={img5} alt='Tarjeta alquiler para control de socio y fecha' className='imagenCentrada' style={{width: '50%'}}/>
            
            <h3>¿Te puedes imaginar de qué negocio se trataba?</h3>  
        

</>
       
    )
    
}

export default Article1